function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import { DynamicDistributedAssets } from './distributedAssets-dynamicitems';
import { ManageAirWindowsDialogController } from './dialogs/manageAirWindowsDialog-controller'; //// CONTROLLER ////

export var DistributedAssetsGridController =
/*#__PURE__*/
function () {
  _createClass(DistributedAssetsGridController, null, [{
    key: "$inject",
    get: function get() {
      return ['$stateParams', '$rootScope', '$scope', '$q', 'DeliveryResourceFactory', 'DestinationResourceFactory', 'AssetResourceFactory', 'NotificationService', '$timeout', '$state', '$mdDialog'];
    }
  }]);

  function DistributedAssetsGridController($stateParams, $rootScope, $scope, $q, DeliveryResourceFactory, DestinationResourceFactory, AssetResourceFactory, NotificationService, $timeout, $state, $mdDialog) {
    _classCallCheck(this, DistributedAssetsGridController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $stateParams: $stateParams,
      $rootScope: $rootScope,
      $scope: $scope,
      $q: $q,
      DeliveryResourceFactory: DeliveryResourceFactory,
      DestinationResourceFactory: DestinationResourceFactory,
      AssetResourceFactory: AssetResourceFactory,
      NotificationService: NotificationService,
      $timeout: $timeout,
      $state: $state,
      $mdDialog: $mdDialog
    });
    var vm = this;
    /* BINDABLE : DATA */

    vm.sortObj = {
      field: this.$stateParams.sortField,
      direction: this.$stateParams.sortDirection
    };
    vm.selectedDeliveries = [];
    /* EVENTS */
    //Register any event listeners
  }

  _createClass(DistributedAssetsGridController, [{
    key: "displayCorrectAdvertiser",
    value: function displayCorrectAdvertiser(delivery) {
      var vm = this; // If the user is searching by advertiser, then all rows should match that advertiser, short-circuit

      if (vm.$stateParams.advertiser) {
        return vm.$stateParams.advertiser;
      } // If this metadata override does not exist in memory yet, just return blank


      if (vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id] === undefined) {
        return '';
      }

      if (vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id].advertiser) {
        return vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id].advertiser;
      } else if (delivery.OrderGroup.DistributionOrder.Advertiser.name) {
        return delivery.OrderGroup.DistributionOrder.Advertiser.name;
      } else {
        return delivery.Spot.Advertiser.name;
      }
    }
  }, {
    key: "displayCorrectCampaign",
    value: function displayCorrectCampaign(delivery) {
      var vm = this; // If the user is searching by advertiser, then all rows should match that advertiser, short-circuit

      if (vm.$stateParams.campaign) {
        return vm.$stateParams.campaign;
      } // If this metadata override does not exist in memory yet, just return blank


      if (vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id] === undefined) {
        return '';
      }

      if (vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id].campaign) {
        return vm.dynamicItems.metadataOverrides[delivery.Spot.id + '-' + delivery.OrderGroup.DistributionOrder.id + '-' + delivery.OrderGroup.id].campaign;
      } else if (delivery.OrderGroup.DistributionOrder.Campaign.name) {
        return delivery.OrderGroup.DistributionOrder.Campaign.name;
      } else {
        return delivery.Spot.Campaign.name;
      }
    }
    /* IMPLEMENTATION : BINDABLE */

  }, {
    key: "sortDeliveries",
    value: function sortDeliveries(field) {
      var vm = this;

      if (vm.sortObj.field === field) {
        vm.sortObj.direction = vm.sortObj.direction === 'ASC' ? 'DESC' : 'ASC';
      } else {
        vm.sortObj.field = field;
        vm.sortObj.direction = 'ASC';
      }

      this.$state.go('distributedAssetsList', {
        sortField: vm.sortObj.field,
        sortDirection: vm.sortObj.direction,
        sortType: 'delivery'
      }, {
        inherit: true
      });
    }
  }, {
    key: "checkSpotDates",
    value: function checkSpotDates(deliveredAsset) {
      if (!deliveredAsset) {
        return false;
      }

      if (moment(deliveredAsset.OrderGroup.DistributionOrder.flightStart).isBefore(moment(deliveredAsset.Spot.runStartDate)) || moment(deliveredAsset.OrderGroup.DistributionOrder.flightEnd).isAfter(moment(deliveredAsset.Spot.runEndDate))) {
        return false;
      }

      return true;
    }
  }, {
    key: "selectDelivery",
    value: function selectDelivery(delivery, index, event) {
      var vm = this;

      if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
        vm.selectedDeliveries = [];
      }

      if (event.shiftKey && vm.lastSelection > -1) {
        // Do multiselect
        var toIndex = Math.max(index, vm.lastSelection);
        var fromIndex = Math.min(index, vm.lastSelection);

        for (var i = fromIndex; i <= toIndex; i++) {
          if (vm.selectedDeliveries.indexOf(i) < 0) {
            vm.selectedDeliveries.push(i);
          }
        }
      } else if (vm.selectedDeliveries.indexOf(index) < 0) {
        vm.selectedDeliveries.push(index);
      } else {
        vm.selectedDeliveries.splice(vm.selectedDeliveries.indexOf(index), 1);
      }

      vm.lastSelection = index;
    }
  }, {
    key: "openManageAirWindowDialog",
    value: function openManageAirWindowDialog() {
      var vm = this; // Loop through selected deliveries and filter to create two lists:
      // - one with deliveries that can't be modified
      // - one with deliveries that can

      var validToManage = [];
      var invalidToManage = [];
      var invalidMessage = 'The following ISCIs are not valid for updating the rights window:<br /><ul>';

      for (var i = 0; i < vm.selectedDeliveries.length; i++) {
        var tempGrab = vm.dynamicItems.getItemAtIndex(vm.selectedDeliveries[i]);

        if (moment(tempGrab.OrderGroup.DistributionOrder.flightEnd).hour(23).minute(59).second(59).isBefore(moment()) || moment(tempGrab.Spot.runEndDate).isBefore(moment()) || tempGrab.Spot.status === 'PENDING_MEDIA' || tempGrab.OrderGroup.DistributionOrder.deliveryStatus !== 'COMPLETED') {
          invalidToManage.push(tempGrab);
          invalidMessage += '<li>' + tempGrab.Spot.isci + '</li>';
        } else {
          tempGrab.callLetters = vm.dynamicItems.destinationCallLetters[tempGrab.Spot.id + '-' + tempGrab.OrderGroup.id];
          tempGrab.destinations = vm.dynamicItems.orderGroupDestinations[tempGrab.Spot.id + '-' + tempGrab.OrderGroup.id];
          tempGrab.referenceLink = vm.dynamicItems.referenceLinks[tempGrab.Spot.id + '-' + tempGrab.OrderGroup.DistributionOrder.id];
          tempGrab.metadataOverride = vm.dynamicItems.metadataOverrides[tempGrab.Spot.id + '-' + tempGrab.OrderGroup.DistributionOrder.id + '-' + tempGrab.OrderGroup.id];
          tempGrab.spotThumb = vm.dynamicItems.deliveryThumbs[tempGrab.Spot.isci];
          tempGrab.selectedStartFlightDate = tempGrab.OrderGroup && tempGrab.OrderGroup.DistributionOrder && tempGrab.OrderGroup.DistributionOrder.flightStart && moment().isBefore(moment(tempGrab.OrderGroup.DistributionOrder.flightStart)) ? moment(tempGrab.OrderGroup.DistributionOrder.flightStart) : moment().format('MM/DD/YYYY');
          tempGrab.selectedEndFlightDate = tempGrab.OrderGroup && tempGrab.OrderGroup.DistributionOrder && tempGrab.OrderGroup.DistributionOrder.flightEnd ? moment(tempGrab.OrderGroup.DistributionOrder.flightEnd).format('MM/DD/YYYY') : undefined;
          validToManage.push(tempGrab);
        }
      }

      var continueOrNot; // If there are unmanagable deliveries we need to show a notification

      if (invalidToManage.length > 0) {
        invalidMessage += '</ul><br />Do you wish to continue anyway?';
        var confirm = vm.$mdDialog.confirm().title('Warning').htmlContent(invalidMessage).ariaLabel(invalidMessage).ok('Yes').cancel('No');
        continueOrNot = vm.$mdDialog.show(confirm);
      } else {
        continueOrNot = vm.$q.when(true);
      }

      continueOrNot.then(function () {
        vm.$mdDialog.show({
          controller: ManageAirWindowsDialogController,
          controllerAs: 'vm',
          template: require('./dialogs/manageAirWindowsDialog-template.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: true,
          // For small screens only
          locals: {
            deliveries: validToManage
          }
        }).then(function submitted(info) {
          // Deselect the rows when the user is finished
          vm.selectedDeliveries = [];
          vm.$state.reload(); // Check info param to see whether the operation was a complete success or not

          vm.NotificationService.showNotificationToast(info.message, info.failure > 0 ? 'Successes: ' + info.success + '<br />Failures: ' + info.failure : undefined);
        }, function cancelled() {
          // Deselect the rows when the user is finished
          vm.selectedDeliveries = [];
        });
      }, function () {// What to do if they don't want to continue
      });
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {
      var vm = this;
      vm.bowser = bowser;
      this.dynamicItems = new DynamicDistributedAssets(this.$stateParams, this.$timeout, this.DeliveryResourceFactory, this.AssetResourceFactory, this.DestinationResourceFactory);
    }
  }]);

  return DistributedAssetsGridController;
}();